<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      任务实例
    </p>
    <template slot="extra"> </template>
    <Row>
      <!-- <Col span="24"> -->
      <Input v-model="query.bizId" placeholder="bizId" class="public-inp md5" />
      <Input v-model="query.instanceId" placeholder="instanceId" class="public-inp md5" />
      <Input v-model="query.templateCode" placeholder="templateCode" class="public-inp md5" />
      <span class="public-stretch" @click="open = !open">
        <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" />{{
            open ? "收起" : "展开"
        }}
      </span>
      <Button type="primary" icon="md-add" class="public-fr" @click="addFn()"
        v-access="'datax.instance.add'">添加模版</Button>
      <Button class="public-fr" @click="reset()" v-access="'datax.instance.reset'">重置</Button>
      <Button class="public-fr" type="primary" icon="ios-search" @click="getList()"
        v-access="'datax.instance.query'">查询</Button>
      <!-- </Col> -->
    </Row>

    <Row v-if="open">
      <Select filterable clearable v-model="query.status" placeholder="请选择任务状态" style="width: 200px">
        <Option v-for="(option, index) in statusList" :value="option.value" :key="index" :label="option.lable">
        </Option>
      </Select>
    </Row>

    <Row>
      <!-- <Col span="24"> -->
      <Table :style="{ marginTop: '10px' }" border stripe :loading="loading" :columns="columns" :data="tbList">
        <template slot-scope="{ row, index }" slot="sort">
          <span v-show="false">{{ row.code }}</span>
          {{ index + 1 }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <a href="javascript:;" @click="detailFn(row)" v-access="'datax.instance.details'">详情</a>
        </template>
      </Table>
      <Page :style="{ float: 'right', marginTop: '10px' }" :total="total" show-sizer show-total prev-text="上一页"
        next-text="下一页" show-elevator @on-change="pageNumChange" @on-page-size-change="pageSizeChange" />
      <!-- </Col> -->
    </Row>
    <Modal v-model="modalDetail" title="内容预览" :loading="detailLoading" :mask-closable="false" width="800px">
      <table>
        <row>
          <th>jobParams：</th>
          <td>{{ detail.jobParams }}</td>
        </row>
        <row>
          <th style="align: top">jobContent：</th>
          <td>
            <textarea disabled="disabled" placeholder="请输入模版内容"
              style="width: 700px; height: 800px; padding: 5px">{{ detail.jobContent }}</textarea>
          </td>
        </row>
        <row>
          <th>remark：</th>
          <td>{{ detail.remark }}</td>
        </row>
      </table>
    </Modal>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        rows: 10,
        instanceId: "",
        bizId: "",
        templateCode: "",
        status: null,
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 80,
          fixed: "left",
        },
        {
          title: "instanceId",
          key: "instanceId",
          width: 170,
        },
        {
          title: "bizId",
          key: "bizId",
          width: 200,
        },
        {
          title: "templateCode",
          key: "templateCode",
          width: 250,
        },
        {
          title: "jobParams",
          key: "jobParams",
          width: 250,
        },
        {
          title: "threadInfo",
          key: "threadInfo",
          width: 170,
        },
        {
          title: "开始时间",
          key: "startTime",
          width: 170,
        },
        {
          title: "结束时间",
          key: "endTime",
          width: 150,
          fixed: "right",
        },
        {
          title: "状态",
          key: "status",
          width: 90,
          fixed: "right",
          render: (h, params) => {
            let name = "";
            if (params.row.status == 0) name = "初始化";
            else if (params.row.status == 1) name = "处理中";
            else if (params.row.status == 7) name = "失败";
            else if (params.row.status == 8) name = "处理成功";
            return h("div", name);
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          fixed: "right",
        },
      ],
      statusList: [
        {
          value: 0,
          lable: "初始化",
        },
        {
          value: 1,
          lable: "处理中",
        },
        {
          value: 7,
          lable: "处理失败",
        },
        {
          value: 8,
          lable: "处理成功",
        },
      ],
      tbList: [],
      loading: false,
      total: 0,
      modalDetail: false,
      detailLoading: false,
      detail: {
        jobParams: "",
        jobContent: "",
        remark: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getDataXTaskList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.bizId = "";
      this.query.instanceId = "";
      this.query.templateCode = "";
      this.query.status = null;
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    addFn() {
      this.$router.push({
        name: "instanceAdd",
      });
    },
    detailFn(row) {
      this.modalDetail = true;
      this.$api.getDataXDetail({ insId: row.instanceId }).then((res) => {
        if (res.code == "200") {
          this.detail = res.data;
          this.detail.jobContent = JSON.stringify(
            JSON.parse(res.data.jobContent),
            null,
            " "
          );
        }
      });
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/datax/instance.vue